<template>
<div>
  <!-- <total-result-header ym_from="单车对比-一级指标" :data="data"/> -->
  <div class="white_bg">
    <div class="analyse_item">
      <NodeName
        :node_name="'功能评测得分：'+data.base_score+'分'"
      />
    </div>

    <div class="analyse_item" style="padding-top:30px;">
      <div class="charts">
        <div class="chart_item" v-for="(opt_item,opt_ind) in options_list"
          :class="cur_node_id?(cur_node_id == opt_item.node_id?'':'chart_opacity'):''"
          :key="opt_ind">
          <div class="item_node_name">
            {{opt_item.node_name}}（{{opt_item.score}}分）
          </div>
          <div @click="cur_node_id=opt_item.node_id">
            <v-chart
              ref="barChart"
              class="bar_chart"
              :option="opt_item.options"
              :style="{'width':100+(700/18)*opt_item.options.xAxis.data.length+'px','height':'300px'}"
              autoresize
              @click="echartsClick"
            />
          </div>
        </div>
      </div>
      
    </div>
    <!-- <div class="analyse_item analyse_item3" v-if="l2_node_id">
      <LineChartComponent 
        :node_id="l2_node_id"
        :models="model_list"
        @handel="l2_click"
        @loadEnd="goAnthor('.analyse_item3')"
      />
    </div> -->
    <div class="analyse_item analyse_item2" v-show="tree_table_data">
      <!-- <div class="analyse_item_tile">
        <div class="analyse_item_tile_before">
          <div class="analyse_item_tile_before_left"></div>
          <div class="analyse_item_tile_before_right"></div>
        </div>
        <div class="analyse_item_tile_text">
          {{cur_target_node_name}}
        </div>
      </div> -->
      <NodeName 
        :node_name="'功能项评测-'+cur_target_node_name"
      />
      <tree-table-base
        v-loading="tree_table_loading"
        :data_type="1"
        :model_list="model_list"
        :data="tree_table_data"
      >
      </tree-table-base>
    </div>
  </div>
</div>
 
</template>
<script>
import { ElMessage } from "element-plus";
import { getCarSummaryDataV2 ,getCarScoreV2} from "@/api";
import { ref } from "vue";
import { useRoute } from "vue-router";
// import TotalResultHeader from "@/components/contrast/single/TotalResult.vue";
// import ModelIndicator from "@/components/contrast/single/ModelIndicator.vue";
import TreeTableBase from "@/components/v2/common/views/treeTable/TreeTableBase.vue"
import NodeName from "@/components/common/views/NodeName.vue";
// import LineChartComponent from "@/components/echarts/LineChartComponent.vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {BarChart } from "echarts/charts";
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  BarChart,
]);
import VChart from "vue-echarts";
export default {
  name: "Analyse",
  components: {
    VChart,
    // TotalResultHeader,
    // ModelIndicator,
    TreeTableBase,
    NodeName
    // LineChartComponent
  },
  setup() {
    const route = useRoute();
    let { model_id,report_id,node_id=""} = route.query;
    const cur_node_id = ref(node_id);
    const _getData = () => {
      getCarSummaryDataV2({
        model_id,
        get_base:1
      }).then((res) => {
        if (res.code == 200) {
          const callData = res.data;
          callData.stars_per = Number(res.data.stars_per);
          const levelOneIds = [];
          if (callData.performance_score_detail) {
            callData.performance_score = 0;
          }
          data.value = callData;
          data.value.levelOneIds = levelOneIds;
          model_list.value = [{model_id,report_id,model_name:callData.brand+" "+callData.model_name}]
        } else if (res.code == 501) {
          //未登录处理
        } else {
          ElMessage.error(res.message);
        }
      })
      getCarScoreV2({
        model_id,
        report_id,
        node_id:4921
      }).then(res=>{
        renderBarChartOptions(res.data.list)
      })
    };
    const color_list = ['#69a8f0', '#AEDAAE', '#b0d8f5', '#5cbe85', '#f2d0a7', '#e1b0bb', '#EAC0EA', '#fac858', '#ee6666'];
    // color_list =['#f00', '#0f0', '#00f', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fac858', '#ee6666'];
    const data = ref({});
    const options_list = ref([]);
    let node_info_list = [];
    let node_name_parent = {};
    let node_flat_child = {};
    const renderBarChartOptions = (list)=>{
      node_info_list = list.map(item=>{
        return item.child.map((child_item)=>{
          node_name_parent[child_item.node_name] = item.node_name;
          node_flat_child[child_item.node_name] = child_item.child;
          return {
            node_name:child_item.node_name,
            node_id:child_item.node_id,
          }
        })
      }).flat(Infinity)
      // var hr = new Image();
      // hr.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjyFj7/D8ABnkC/INB6LMAAAAASUVORK5CYII=";
      options_list.value = list.map(item=>{
        return {
          node_name:item.node_name,
          node_id:item.node_id,
          score:item.score,
          options:{
            grid: {
              show: true,
              backgroundColor: "rgba(250, 250, 250, .6)",
              borderColor: "rgba(255, 255, 255, 1)",
              left:'40px',
              top:'20px',
              right:'10px'
            },
            xAxis: {
              type: 'category',
              data: item.child.map(child_item=>{
                return child_item.node_name
              }),
              triggerEvent: true,
              axisLabel: {
                color:"#2192ff",
                show:true,
                fontSize:10,
                lineHeight:14,
                hideOverlap:false,
                interval:0,
                formatter: function (value) {
                    var ret = "";//拼接加\n返回的类目项  
                    var maxLength = 4;//每项显示文字个数  
                    var valLength = value.length;//X轴类目项的文字个数  
                    var rowN = Math.ceil(valLength / maxLength)>2?2:Math.ceil(valLength / maxLength); //类目项需要换行的行数 
                    if(valLength>8){
                      maxLength =  Math.ceil(valLength/2)
                    }
                    if (rowN > 1)//如果类目项的文字大于4,  
                    {
                        for (var i = 0; i < rowN; i++) {
                          var temp = "";//每次截取的字符串  
                          var start = i * maxLength;//开始截取的位置  
                          var end = start + maxLength;//结束截取的位置  
                          temp = value.substring(start, end) + "\n";
                          ret += temp; //凭借最终的字符串  
                        }
                        return ret;
                    }
                    else {
                        return value+"\n";
                    }
                },
              }
             
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                color: "#404248",
                fontSize: 8,
                padding: [0, 0, 0, 0],
                formatter: "{value} %",
              },
              splitNumber: 5,
              min: 0,
              max: 100,
              axisLine:{
                show:false,
              }
            },
            series: [
              {
                data: item.child.map((child_item,child_ind)=>{
                  return {
                    value: child_item.score/child_item.total_score*100,
                    itemStyle: {
                      color: color_list[child_ind]
                    },
                    label: {
                      show:true,     
                      color: "#404248",
                      fontSize: 10,
                      position: "top",
                      formatter: () => {
                        return (child_item.score/child_item.total_score*100).toFixed(2);
                      },
                    },
                  }
                }),
                type: 'bar',
                barMinHeight:5,
                barWidth:25
              }
            ]
          }
        }
      })
    }

    _getData();
     // 二级
    const l2_node_id = ref(null);
    const l2_click = (node)=>{
      tree_table_data.value = [];
      tree_table_loading.value=true;
      cur_target_node_name.value = node.node_name;
       let query_info_list = [{
        model_id,
        report_id,
        node_id:node.node_id,
        need_own:1
      }]

      let promise_list = query_info_list.map(item=>{
        return new Promise((resolve,reject)=>{
          getCarScoreV2(item)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
        })
      })
      Promise.all(promise_list).then((res_list) => {
        tree_table_data.value = res_list; 
        tree_table_loading.value = false;
        goAnthor(".analyse_item2")
      })
    }
    const cur_target_node_name = ref("");
    const tree_table_data = ref(null);
    const model_list = ref([{model_id,report_id,model_name:data.value.model_name}])
    const tree_table_loading = ref(false);
    const echartsClick = (params) => {
      // let cur_child = [];
      let click_node_name = "";
      if(params.componentType == "series"){
        click_node_name = params.name;
        // cur_child = node_flat_child[params.name];
      }else if(params.componentType == "xAxis"){
         click_node_name = params.value;
        //  cur_child = node_flat_child[params.value];
      }
      let node_id = 0;
      let node_name = "";
      cur_target_node_name.value = node_name_parent[click_node_name]+"-"+click_node_name;
      node_info_list.forEach(item=>{
        if(click_node_name == item.node_name){
          node_id = item.node_id;
          node_name = item.node_name;
        }
      })
      // if(cur_child.length>1){
      //   l2_node_id.value = node_id;
      //   tree_table_data.value = null;
      // }else{
        l2_click({node_id,node_name});
        l2_node_id.value = null;
      // }

     
    }
    const goAnthor = (selector)=>{
      setTimeout(() => {
        const height = document.querySelector(selector).offsetTop;
        const container = document.querySelector('.el-main');
        container.scrollTo({
          top:height-150,
          behavior: 'smooth'
        })
      }, 100);
    };


    return {
      data,
      options_list,
      echartsClick,
      tree_table_data,
      model_list,
      cur_target_node_name,
      tree_table_loading,
      goAnthor,
      l2_node_id,
      l2_click,
      cur_node_id
    };
  },
};
</script>
<style scoped lang="less">
.white_bg {
  /* width: 1250px; */
  padding: 37px 48px;
  min-width: 1090px;
  display: inline-block;
}
.fond_14 {
  font-size: 14px;
}
.font_weight {
  color: #404248;
  font-weight: bold;
}
.border_right::after,
.border_left::before {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  content: "";
  width: 1px;
  height: 100%;
  background-color: #dde5fd;
}
.border_left::before {
  left: 0;
  right: auto;
}

.analyse_item {
  position: relative;
  margin-bottom: 30px;
  .charts{
    .chart_item{
      &.chart_opacity{
        opacity: .3;
      }
      .item_node_name{
        cursor: pointer;
        text-align: center;
        color:#3c3c3c;
        margin-bottom: 10px;
      }
    }
  }
  &.analyse_item2 {
    min-height: 500px;
    margin-bottom: 0;
    h2{
      margin-bottom: 10px;
    }
  }
  .search_leaf_node{
    width: 253px;
    height: 33px;
    background-position: 179px center;
    border-radius: 2px;
    position: absolute;
    top:0;
    right: 26px;
    display: flex;
    align-items: center;
    border: 1px solid #d7d7d7;
    input{
      width: 100%;
      height: 100%;
      appearance: none;
      outline: none;
      border: none;
      background: transparent;
      padding: 0 10px 0 30px;
      font-size: 14px;
      &::placeholder{
        color: #bebebe;
      }
    }
    &:has(input:focus){
      border: 1px solid #1FBCBF;
    }
    .search_leaf_button{
      width: 50px;
      height: 100%;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png) no-repeat center center;
      background-size: 17px 17px;
      cursor: pointer;
    }
  }
  h2 {
    position: relative;
    padding-left: 31px;
    font-size: 18px;
    color: #404248;
    font-weight: bold;
    margin-bottom: 33px;
    line-height: 20px;
    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: "";
      width: 5px;
      height: 20px;
      background-color: #4ed6f7;
      border-radius: 2px;
    }
    strong {
      margin-left: 8px;
      color: #e7816e;
    }
  }
  .item_chart {
    align-items: flex-start;
  }
}
.analyse_table {
  min-width: 995px;
  border-radius: 10px;
  border: 1px solid #dde5fd;
  color: #404248;
  font-size: 14px;
  overflow: hidden;
  margin-top: 120px;
  background: #FBFDFF;
  .car_msg {
    flex-direction: column;
    padding: 26px 30px;
    border-right: 1px solid #eef2fe;
    .to_detail_btn {
      margin-top: 30px;
      width: 156px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      font-size: 12px;
      border: 1px solid #e8e8e8;
      color: #7e7e7e;
      letter-spacing: 1px;
      outline: none;
      background-color: #fff;
      cursor: pointer;
      &:last-child {
        margin-left: 14px;
      }
    }
  }
  .car_img {
    width: 220px;
    height: 147px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  .car_name {
    text-align: center;
    font-size: 16px;
    color: #474747;
  }
  .td {
    height: 100%;
    padding: 0 28px;
    flex-grow: 0;
  }
  .th .td {
    position: relative;
  }
  .tr {
    .to_detail_btn {
      color: #709ae8;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .row {
    min-height: 64px;
    text-align: center;
    border-bottom: 1px solid #dde5fd;
 
    &:last-child {
      border-bottom: none;
    }
    .td:first-child {
      width: 156px;
    }
   
  }
  .scores {
    margin-top: 6px;
  }
  .completeness {
    margin-left: 10px;
  }
}
.innovate_analyse_table {
  min-width: 473px;
  .td {
    min-width: 120px;
  }
}
.performance_chart_item {
  text-align: center;
  font-size: 16px;
  .score {
    margin-top: 8px;
    strong {
      font-size: 18px;
    }
    span {
      color: #858a97;
    }
    .slash {
      padding: 0 8px;
    }
  }
  .to_detail_btn {
    width: 142px;
    height: 32px;
    line-height: 31px;
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid #e8e8e8;
    color: #404248;
    cursor: pointer;
  }
}
// :deep(.el-progress-bar){
//     width: 214px;
// }
.charts{
  display: flex;

}

.analyse_item_tile{
  height: 46px;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  margin-bottom: 20px;
  .analyse_item_tile_text{
    line-height: 46px;
    font-size: 14px;
    font-weight: bold;
    color: #0E0A31;
  }
  .analyse_item_tile_before{
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    .analyse_item_tile_before_left{
      width: 24px;
      height: 2px;
      background: #1FBCBF;
    }
    .analyse_item_tile_before_right{
      width: 38px;
      height: 2px;
      background: #DCDCDC;
    }
  }
}
</style>